import { takeLatest, all, put, fork } from 'redux-saga/effects'

import * as actions from '../actions/actions'

export default function* authNavbarSaga() {
    yield all([
        fork(watchAuthNavbarBankIdBankRequest)
    ]);
}

function* watchAuthNavbarBankIdBankRequest() {
    yield takeLatest(
        actions.AUTH_NAVBAR_BANK_ID_REQUEST,
        authNavbarBankIdRequest
    )
}

function* authNavbarBankIdRequest(bankId) {
    yield put({
        type: actions.AUTH_NAVBAR_BANK_ID,
        value: bankId.value
    })
}